import dynamic from "next/dynamic";

import { useMemo } from "react";

import classNames from "classnames";

import { collectionUrl } from "components/CollectionPageLayout";
import ShareButton from "components/ShareButton";
import { useApi } from "hooks/useApi";
import { emberAppBaseUrl } from "utils/envVariables";

const FollowCollectionButton = dynamic(
  () => import("components/FollowCollectionButton")
);

export const CollectionCardButtons = ({ slug, hideShareButton }: any) => {
  const { data: collection } = useApi(collectionUrl(slug));

  const name = collection?.name;
  const link = `${emberAppBaseUrl}/collections/${collection.slug}`;
  const title = `Check this out: ${name} ${link}`;

  const shareBtnOptions = useMemo(
    () => ({
      email: {
        link: `mailto:?subject=\u272a Smartkarma | ${name}&body=${title}`,
      },
      clipboard: {
        message: title,
      },
      privateMessage: {
        message: `Collection | ${name}: <a href="${link}">${link}</a>`,
      },
      whatsapp: {
        link: `https://web.whatsapp.com/send?text=${title}`,
      },
      twitter: {
        link: `https://twitter.com/share?url=${link}&text=${title}&via=smartkarma`,
      },
      linkedIn: {
        link: `https://www.linkedin.com/shareArticle?mini=true&url=${link}&source=Smartkarma`,
      },
    }),
    [link, name, title]
  );

  return (
    <div className={classNames("flex", "space-x-[10px]")}>
      <FollowCollectionButton collection={collection} />
      {!hideShareButton && (
        <ShareButton
          collection={collection}
          options={shareBtnOptions}
          columnView
          type="pill-button"
          noTooltip
        >
          Share
        </ShareButton>
      )}
    </div>
  );
};

export default CollectionCardButtons;
